import { useMemo } from 'react';
import { ECARD_DATE_FORMATS } from '@shared/components/EmailsAndEcards/components/Design/Design.constants';
import { EcardType } from '@graphql/generated';
import { getFormattedDate } from '@apps/ecard/Ecard.utils';
import { withWindow } from '@shared/utils/withWindow';
import { useEcardsTelemetry } from '@apps/ecard/Ecard.telemetry';
import { isCustomECardType } from '@apps/ecard/Ecard.utils';

interface useEcardContentEditorControllerArgs
  extends Readonly<{
    date: string;
    ecardDraftType: EcardType;
    eventHandle: string;
  }> {}

export const useEcardContentEditorController = (args: useEcardContentEditorControllerArgs) => {
  const { date, ecardDraftType, eventHandle } = args;

  const isCustomECard = isCustomECardType(ecardDraftType);

  const dateFormats = useMemo(() => {
    if (isCustomECard) {
      return [];
    }
    return ECARD_DATE_FORMATS.map((dateFormat: string) => {
      return {
        label: getFormattedDate(date, dateFormat),
        value: dateFormat,
      };
    });
  }, [date, isCustomECard]);

  const telemetry = useEcardsTelemetry();
  const onGoToSettingsClick = (linkLabel: 'date' | 'location' | 'url') => {
    telemetry.eCardAdminLinkClick(ecardDraftType, linkLabel);
    withWindow(() => {
      window.open(`${window.location.origin}/${eventHandle}/edit/settings`, '_blank');
    });
  };

  return {
    dateFormats,
    isCustomECard,
    onGoToSettingsClick,
  };
};
